import type { FC } from 'react'
import { useHostStatus } from '@/features/status'
import { HostStatusIcon } from './HostStatusIcon'

interface ConnectedHostStatusIconProps {
  readonly hostname: string
  readonly fontSize?: 'small' | 'inherit' | 'medium' | 'large'
}

export const ConnectedHostStatusIcon: FC<ConnectedHostStatusIconProps> = ({
  hostname,
  fontSize = 'small',
}) => {
  const status = useHostStatus(hostname)
  return <HostStatusIcon status={status} fontSize={fontSize} />
}
